import { contentfulImageLoader } from "@utils/imageLoader";
import { useLocale } from "next-intl";
import { FC } from "react";

import Image from "@/components/ui/Image/Image";
import { TileCarouselCardProps } from "@/types";

import RichText from "../RichText/RichText";
import Button, { ButtonSize, ButtonTheme, ButtonVariant } from "../ui/Button/Button";

const TileCarouselCardContent: FC<{ item: TileCarouselCardProps; openModal: () => void; showInCardMode?: boolean }> = ({
  item,
  openModal,
  showInCardMode = false,
}) => {
  return (
    <div className="group w-full md:w-[255px] relative mb-l">
      {item.image && (
        <div className="relative rounded-lg">
          <img
            src={contentfulImageLoader({ src: item.image.url, width: 255, quality: 80 })}
            srcSet={[255, 310, 510, 620].map((w) => `${contentfulImageLoader({ src: item.image!.url, width: w, quality: 80 })} ${w}w`).join(", ")}
            sizes="(min-width: 1024px) 255px, 67vw"
            className="aspect-2-1 w-full md:w-[255px] h-[453px] shadow-elevation rounded-lg object-cover"
            alt={item.image.title || ""}
            loading="lazy"
            decoding="async"
          />
          {item.logo && (
            <div className={`absolute w-full h-full top-0 rounded-lg left-0 inset-0 ${item.logo ? "img-overlay-5" : "img-overlay-3"}`}></div>
          )}
        </div>
      )}
      {item.logo && (
        <div className="absolute bottom-0 top-0 text-white pt-xs flex justify-center w-1/2 mx-auto left-0 right-0">
          <Image src={item.logo.url} width={item.logo.width || 128} height={item.logo.height || 72} className="h-fit" alt={item.logo.title || ""} />
        </div>
      )}
      <div className="absolute bottom-0 z-10 text-white px-s pb-m w-full text-left md:rtl:text-right tile-carousel-content">
        {item?.overtitle && <div className="font-secondary font-normal text-xs pb-xs">{item.overtitle}</div>}
        <div className="font-secondary text-m font-medium leading-5 pb-xxs tile-carousel-title">{item.title}</div>
        {item.abstract && <div className="font-secondary text-s leading-4 tile-carousel-description">{item.abstract}</div>}
        {item?.abstractRtf && !item?.abstract && (
          <div className="font-secondary text-s leading-4 tile-carousel-description">
            <RichText content={item.abstractRtf} />
          </div>
        )}
        {item.primaryCta && (
          <div className="items-center hidden font-medium md:group-hover:flex mt-s">
            <Button
              // href={projectResultPage ? finalUrl : finalUrlForCommunity}s
              size={ButtonSize.SMALL}
              theme={ButtonTheme.WHITE}
              type="button"
              variant={ButtonVariant.PRIMARY}
              customClass="text-center !border-white hover:!border-0"
              onClick={openModal}
            >
              {typeof item?.primaryCta === "object" && "buttonLabel" in item.primaryCta ? item.primaryCta.buttonLabel : ""}
            </Button>
          </div>
        )}
      </div>
    </div>
  );
};
export default TileCarouselCardContent;
